<template>

    <div class="swiper-container" id="HomePageSlider">

        <div class="swiper-wrapper">
            <slot name="slides"></slot>
        </div>
        <div class="slide-infos">
            <div class="wrapper">
                <div class="pagination">
                    <template v-for="(item, index) in items" >
                        <div class="number" @click="homePageSlider.slideTo(index)" :key="index">{{index+1 | formatedDay}}</div>
                        <div class="bar"
                             :class="[{active: isActiveSlide(index)}, item.index]"
                             :key="index">
                            <div class="fill"
                            ></div>
                        </div>
                    </template>
                </div>
                <a :href="activeItem.url"><h1 class="titre" v-html="activeItem.name"></h1></a>
                <p><a :href="activeItem.url"
                      class="lien-inline link-to-cruise"
                      v-html="activeItem.destination ? activeItem.destination : 'Découvrir le voyage'"></a>
                </p>
            </div>
        </div>

    </div>

</template>

<script>
    import $ from 'jquery';
    import Swiper from 'swiper';
    import {debounce} from 'lodash';

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                homePageSlider: null,
                numbreOfSlide: 0,
                activeIndex: 0,
                activeItem: null,
                swiperStart: false
            };
        },
        computed: {},
        methods: {
            initSwiper() {

                // Init
                this.homePageSlider = new Swiper('#HomePageSlider', {
                    effect: "fade",
                    threshold: 40,
                    speed: 700,
                    autoplay: {
                        delay: 4000,
                        disableOnInteraction: false
                    },
                    lazy: {
                        loadPrevNext: true,
                    },
                    preloadImages: false,
                    on: {
                        slideChange: () => {

                            $('.pagination .bar .fill').removeClass('full first')

                            this.activeIndex = this.homePageSlider.activeIndex

                            this.updateItem()

                            $('.pagination .bar.' + this.activeIndex + ' .fill').addClass('full')

                            this.trigTitleEffect()


                        },
                        // autoplayStop: () => {
                        //     setTimeout(() => {
                        //         this.homePageSlider.autoplay.start();
                        //     }, 3000)
                        // },
                        init: () => {
                            $('.pagination .bar.' + this.activeIndex + ' .fill').addClass('full first')
                            this.trigTitleEffect()
                        },
                    }

                })


            },
            initTimer() {


            },
            isActiveSlide(index) {
                return this.activeIndex === index
            },
            slideToNext() {
                this.activeIndex++
                this.homePageSlider.slideTo(this.activeIndex)
                this.activeItem = this.items[this.activeIndex]

            },
            updateItem() {
                this.activeItem = this.items[this.activeIndex]
            },
            trigTitleEffect(){
                let infosToHide = $('section.home-page-slider .titre, section.home-page-slider .link-to-cruise')

                infosToHide.removeClass('show')

                setTimeout(() => {
                    infosToHide.addClass('show')
                }, 200)

            }

        },
        mounted() {
            this.initSwiper()

        },
        created() {
            this.updateItem()
        },
        destroyed() {

        },
    }
</script>




// WEBPACK FOOTER //
// assets/js/components/home-page/HomeSlider.vue